var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "candidate",
    d: "M13.452,4.285A7,7,0,0,0,0,7.01a7,7,0,0,0,11.95,4.95,7.008,7.008,0,0,0,1.5-7.675ZM7,13a5.958,5.958,0,0,1-3.328-1.012,3.392,3.392,0,0,1,6.657,0A5.958,5.958,0,0,1,7,13ZM7,8.238A2.093,2.093,0,1,1,9.095,6.145,2.1,2.1,0,0,1,7,8.238Zm4.188,3.051A4.364,4.364,0,0,0,8.837,8.641a3.1,3.1,0,1,0-3.672,0,4.364,4.364,0,0,0-2.352,2.648,5.991,5.991,0,1,1,8.376,0Z",
    transform: "translate(0 -0.01)",
    fill: "#00c22d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d81013fe17d62301605b602671213112.svg";
export { ForwardRef as ReactComponent };